export default __webpack_public_path__ + "upload/personal.ab585980.pdf";